import "antd/dist/antd.css";

import Radium from "radium";
import React from "react";

const RegenerationCard = ({
  img,
  setModalOpen,
  title,
  subtitle,
  imageSide,
  backgroundStyle,
  p1,
  p2,
  imageStyle,
}) => {
  return (
    <div
      style={{ ...styles.regenerationCard, ...backgroundStyle }}
      onClick={() => setModalOpen(true)}
    >
      <div style={styles.regenerationCard.info}>
        {imageSide === "left" && (
          <img src={img} alt="" style={{ ...styles.regenerationCard.info.img, ...imageStyle }} />
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <p style={{ ...styles.regenerationCard.p1, ...p1 }}>{title}</p>
          <p style={{ ...styles.regenerationCard.p2, ...p2 }}>{subtitle}</p>
        </div>

        {imageSide === "right" && (
          <img src={img} alt="" style={{ ...styles.regenerationCard.info.img, ...imageStyle }} />
        )}
      </div>
    </div>
  );
};

export default Radium(RegenerationCard);

const query = {
  small: "@media (max-width: 600px)",
  medium: "@media (max-width: 1440px)",
  large: "@media (max-width: 1700px)",
};

const styles = {
  regenerationCard: {
    display: "flex",
    flexDirection: "column",
    width: "260px",
    backgroundColor: "white",
    alignItems: "center",
    borderRadius: "20px",
    padding: "16px",
    [query.large]: { width: "220px" },
    info: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      color: "white",
    },
    p1: {
      fontSize: "16px",
      fontWeight: "700",
      color: "#E9EDF7",
      [query.large]: {
        margin: 0,
      },
    },
    p2: { fontSize: "24px", fontWeight: "700", margin: 0 },
  },
  sliderContainer: {
    sliderComponent: {
      justifyContent: "center",
      handleStyle: {
        backgroundColor: "#78D504",
        borderColor: "white",
      },
      trackStyle: { backgroundColor: "#78D504", height: "6px" },
    },
  },
  buttonContainer: {
    display: "flex",
    backgroundColor: "#78D504",
    borderRadius: "70px",
    border: 0,
    color: "white",
    fontWeight: "600",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
  },
};
